var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormGuide", {
                attrs: {
                  data: _vm.guide,
                  audioguides: _vm.audioguides,
                  cities: _vm.cities,
                  routes: _vm.routes,
                  "shared-access": _vm.sharedAccess,
                  "ticket-reservations": _vm.ticketReservations,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.formGuideSubmit,
                  "delete-guide": _vm.deleteGuide,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  "change:descriptionForMobile": function ($event) {
                    return _vm.changeDescForMobHandler($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmGuideRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }